import heavy_royal1 from '../images/heavy_royal1.jpg'
import heavy_royal2 from '../images/heavy_royal2.jpg'
import heavy_royal3 from '../images/heavy_royal3.jpg'

import heavy_ugl1 from '../images/heavy_ugl1.jpg'
import heavy_ugl2 from '../images/heavy_ugl2.jpg'
import heavy_ugl3 from '../images/heavy_ugl3.jpg'
import heavy_ugl4 from '../images/heavy_ugl4.jpg'
import heavy_ugl5 from '../images/heavy_ugl5.jpg'
import heavy_ugl6 from '../images/heavy_ugl6.jpg'
import heavy_ugl7 from '../images/heavy_ugl7.jpg'

import heavy_yuleba1 from '../images/heavy_yuleba1.jpg'
import heavy_yuleba2 from '../images/heavy_yuleba2.jpg'
import heavy_yuleba3 from '../images/heavy_yuleba3.jpg'

const heavy_data = {
  royal: {
    client: 'Royal Woolf',
    title: 'Container Loading',
    image_array: [
      {
        image: heavy_royal1,
        category: 'mining- heavy industory',
        title: 'Container Loading',
        comment: 'Container loading by the Royal Woolf'
      },
      {
        image: heavy_royal2,
        category: 'mining- heavy industory',
        title: 'Container Loading',
        comment: 'Container loading by the Royal Woolf'
      },
      {
        image: heavy_royal3,
        category: 'mining- heavy industory',
        title: 'Container Loading',
        comment: 'Container loading by the Royal Woolf'
      },
    ]
  },
  ugl : {
    client: 'UGL',
    title: 'Pump Unit',
    image_array: [
      {
        image: heavy_ugl1,
        category: 'mining- heavy industory',
        title: 'Pump Unit',
        comment: 'Pump unit by UGL'
      },
      {
        image: heavy_ugl2,
        category: 'mining- heavy industory',
        title: 'Pump Unit',
        comment: 'Pump unit by UGL'
      },
      {
        image: heavy_ugl3,
        category: 'mining- heavy industory',
        title: 'Pump Unit',
        comment: 'Pump unit by UGL'
      },
      {
        image: heavy_ugl4,
        category: 'mining- heavy industory',
        title: 'Pump Unit',
        comment: 'Pump unit by UGL'
      },
      {
        image: heavy_ugl5,
        category: 'mining- heavy industory',
        title: 'Pump Unit',
        comment: 'Pump unit by UGL'
      },
      {
        image: heavy_ugl6,
        category: 'mining- heavy industory',
        title: 'Pump Unit',
        comment: 'Pump unit by UGL'
      },
      {
        image: heavy_ugl7,
        category: 'mining- heavy industory',
        title: 'Pump Unit',
        comment: 'Pump unit by UGL'
      },
    ]
  },
  yuleba: {
    client: 'Yuleba Minerals',
    title: 'Frac sand beneficication cell',
    image_array: [
      {
        image: heavy_yuleba1,
        category: 'mining- heavy industory',
        title: 'Frac sand beneficication cell',
        comment: 'Frac sand beneficication cell by Yuleba Minerals'
      },
      {
        image: heavy_yuleba2,
        category: 'mining- heavy industory',
        title: 'Frac sand beneficication cell',
        comment: 'Frac sand beneficication cell by Yuleba Minerals'
      },
      {
        image: heavy_yuleba3,
        category: 'mining- heavy industory',
        title: 'Frac sand beneficication cell',
        comment: 'Frac sand beneficication cell by Yuleba Minerals'
      },
    ]
  },
}

export default heavy_data;
